export default __webpack_public_path__ + "static/media/8_instituicoes-publicas.cd681867.png";